import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useUserProfile } from "@/hooks/useUserProfile";
import { UserProfileDetails } from "./UserProfileDetails";
import { ResetPasswordDialog } from "@/components/admin/users/ResetPasswordDialog";

export const UserInfo = () => {
  const { data: profile, isLoading, error } = useUserProfile();
  const [isResetPasswordOpen, setIsResetPasswordOpen] = useState(false);

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    return <div>Erreur lors du chargement du profil</div>;
  }

  if (!profile) {
    return <div>Aucun profil trouvé</div>;
  }

  return (
    <div className="space-y-4">
      <UserProfileDetails profile={profile} />
      <div className="flex justify-end">
        <Button 
          variant="outline"
          onClick={() => setIsResetPasswordOpen(true)}
        >
          Modifier le mot de passe
        </Button>
      </div>
      <ResetPasswordDialog
        isOpen={isResetPasswordOpen}
        onClose={() => setIsResetPasswordOpen(false)}
        userId={profile.id}
      />
    </div>
  );
};